<template>
  <div class="box">
    <div class="header">
      <div class="header-content" :style="{'background-image':'url('+baseConfig.mhTitleBg+')'}">
        <div class="header-logo">
          <img :src="baseConfig.mhLogo" width="792px" class="logo" />
        </div>
        <div class="header-search">
          <a
            title="无障碍通道"
            href="javascript:"
            onclick="ShowDetail()"
            accesskey="g"
            onmousedown="ShowDetail()"
            target="_self"
            class="wzabtn"
            >无障碍模式
          </a>
          <input
            type="text"
            class="input1"
            placeholder="输入搜索内容"
            v-model="searchTitle"
            @keyup.enter="searchClick()"
          />
          <i class="el-icon-search search-icon" @click="searchClick()"></i>
        </div>
        <!-- 导航 -->
        <div class="header-nav">
          <div
            v-for="(item, index) in navList"
            @click="goClick1(index, item)"
            :key="index"
            :class="$route.path == item.path ? 'text-spe' : ''"
          >
            <a>{{ item.text }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 位置路由 -->
    <div
      class="all-content"
      v-if="
        this.$route.path != '/' &&
        this.$route.path != '/general' &&
        this.$route.path != '/zxhy'
      "
    >
      <div class="location">
        <i class="el-icon-location-outline"></i>
        <div class="now-location">当前位置：</div>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="break">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ isOption }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="total" v-if="this.$route.path == '/'">
      <!-- 首页展示内容 -->
      <div class="index">
        <!-- 第一部分 -->
        <div class="section1" @click="goDetails1(hotRow, '热点')">
          <div class="top ellipsis">
            {{ hotRow.title }}
          </div>
          <div class="bottom">
            <div class="bottom-1">
              <span v-html="hotRow.content"> </span>
            </div>
            <div>[查看全文]</div>
          </div>
        </div>
        <!-- 第二部分要闻 -->
        <div class="section2">
          <!-- 轮播 -->
          <div class="section2-left">
            <div class="block">
              <el-carousel
                trigger="click"
                indicator-position="none"
                height="368px"
              >
                <el-carousel-item
                  v-for="(item, index) in swiperList"
                  :key="index"
                >
                  <div>
                    <img
                      :src="item.url"
                      :alt="item.title"
                      class="swiper-img"
                      :onerror="defaultImg"
                    />

                    <div class="swiper-text">{{ item.title }}</div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <!-- 要闻部分 -->
          <div class="section2-left">
            <div class="s2-right-1">
              <div class="s2-right-1-title s3-left-title" style="display: flex">
                <a
                  :class="{ active: topTab == 0 }"
                  @mouseover="topTab = 0"
                  @click="
                    $router.push({
                      path: '/imporantnews',
                    })
                  "
                  >政协要闻</a
                >
                <span class="s3-left-title-spe">|</span>
                <a
                  :class="{ active: topTab == 1 }"
                  @mouseover="topTab = 1"
                  @click="
                    $router.push({
                      path: '/inform',
                    })
                  "
                  >通知公告</a
                >
              </div>
              <div v-if="topTab == 0">
                <ul>
                  <li
                    v-for="(item, index) in imporantnewsList.slice(0, 8)"
                    :key="index"
                    @click="goDetails1(item, '政协要闻')"
                  >
                    <img
                      src="../../static/image/home/list01.png"
                      class="list1"
                    />
                    <a>{{ item.title }}</a>
                  </li>
                </ul>
              </div>
              <div v-if="topTab == 1">
                <ul>
                  <li
                    v-for="(item, index) in tabTaggList"
                    :key="index"
                    @click="goDetails1(item, '通知公告')"
                  >
                    <img
                      src="../../static/image/home/list01.png"
                      class="list1"
                    />
                    <a>{{ item.title }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="section4">
          <div class="flexbox">
            <div class="w50p mr4">
              <div>
                <img
                  src="../assets/v2img/4.png"
                  alt="平顶山政协委员网上履职客户端上线了"
                  title="平顶山政协委员网上履职客户端上线了"
                  height="78px"
                />
              </div>
              <div>
                <img
                  :src="baseConfig.mhBanner"
                  alt=""
                  style="width:100%;height:78px"
                  @click="$router.push({ path: '/zhuanlan' })"
                />
              </div>
            </div>
            <div class="flexbox flexcolumn">
              <div class="flexbox">
                <div class="flexbox mr4">
                  <img
                    src="../assets/v2img/6.png"
                    alt="全体会议"
                    title="全体会议"
                    @click="
                      $router.push({
                        path: '/zxhy',
                        query: { name: '政协全体会议', classifyId: 25 },
                      })
                    "
                    height="78px"
                  />
                </div>
                <div class="flexbox mr4">
                  <img
                    src="../assets/v2img/12.png"
                    @click="
                      $router.push({
                        path: '/zxhy',
                        query: { name: '政协常委会议', classifyId: 26 },
                      })
                    "
                    alt="常委会议"
                    title="常委会议"
                    height="78px"
                  />
                </div>
                <div class="flexbox mr4">
                  <img
                    src="../assets/v2img/13.png"
                    alt="主席会议"
                    title="主席会议"
                    @click="
                      $router.push({
                        path: '/zxhy',
                        query: { name: '政协主席会议', classifyId: 27 },
                      })
                    "
                    height="78px"
                  />
                </div>
              </div>
              <div class="flexbox">
                <div class="flexbox mr4">
                  <img
                    src="../assets/v2img/7.png"
                    alt="意见征集"
                    title="意见征集"
                    @click="goClick2(16)"
                    height="78px"
                  />
                </div>
                <div class="flexbox mr4">
                  <img
                    src="../assets/v2img/11.png"
                    alt="留言板"
                    title="留言板"
                    @click="goClick2(17)"
                    height="78px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第三部分 -->
        <div class="section3">
          <!-- 时政动态 -->
          <div class="section3-left">
            <one-content
              :names="'时政动态'"
              :id="3"
              :path="'/democratic'"
            ></one-content>
          </div>
          <!-- 专委会工作 -->
          <div class="section3-left">
            <one-content
              :names="'视察调研'"
              :id="19"
              :path="'/scdy'"
            ></one-content>
          </div>
          <!-- 问卷调查 -->

          <div class="section3-left ">
            <div>
              <img
                src="../assets/v2img/10.png"
                alt="智慧政协平台"
                title="智慧政协平台"
                width="100%"
              />
            </div>
            <div class="flexbox">
              <div class="flexbox mr4">
                <a target="_blank" href="/web.html" style="width:100%">
                  <img
                    src="../assets/v2img/8.png"
                    alt="政协委员入口"
                    title="政协委员入口"
                    width="100%"
                  />
                </a>
              </div>
              <div class="flexbox">
                <a target="_blank" href="/admin.html" style="width:100%">
                  <img
                    src="../assets/v2img/9.png"
                    alt="工作人员入口"
                    title="工作人员入口"
                    width="100%"
                  />
                </a>
              </div>
            </div>
            
            <div class="appDownload">
              <div class="tit">政协委员履职App下载安装</div>
              <div class="flexRow imgs">
                <div class="flexRow">
                  <img :src="appImgs.androidImg" />
                  <span>安卓版客户端</span>
                </div>
                <div class="flexRow">
                  <img :src="appImgs.iosImg" />
                  <span>苹果版客户端</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第四部分 -->

        <!-- 第五部分 -->
        <div class="section5">
          <!-- 图片部分 -->
          <div class="s5-left" style="width:100%">
            <div
              class="s3-left-title"
              @click="$router.push({ path: '/tupian' })"
            >
              <a>图片新闻</a>
            </div>
            <div class="ohidden">
              <div class="s5-left-bottom">
                <div
                class="flexbox"
                v-for="(item, index) in tpList.slice(0, 4)"
                :key="index"
                @click="goDetails1(item, '图片新闻')"
              >
                <a class="flexbox flexcolumn mr36">
                  <div class="div-img">
                    <img :src="item.img" class="s5-left-bottom-1-img" />
                  </div>
                  <div class="s5-left-bottom-1-text">{{
                    item.title.slice(0, 20)
                  }}</div>
                </a>
              </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 第六部分 -->
        <div class="section6">
          <!-- 提案工作 -->
          <div class="section3-left">
            <one-content
              :names="'提案工作'"
              :id="5"
              :path="'/proposer'"
            ></one-content>
          </div>
          <!-- <two-content
            :name1="'提案工作'"
            :name2="'社情民意'"
            :id1="5"
            :id2="6"
            :path1="'/proposer'"
            :path2="'/social'"
          ></two-content> -->
          <div class="section3-left">
            <one-content
              :names="'专委会工作'"
              :id="4"
              :path="'/specialCommittee'"
            ></one-content>
          </div>
          <!-- 县区政协 -->
          <two-content
            :name1="'县区政协'"
            :name2="'民主党派'"
            :id1="10"
            :id2="31"
            :path1="'/county'"
            :path2="'/mzdp'"
          ></two-content>
          <div class="section3-left">
            <one-content
              :names="'委员天地'"
              :id="14"
              :path="'/committeemember'"
            ></one-content>
          </div>
          <!-- 以史资政 -->

          <!-- 机关建设 -->
          <div class="section3-left">
            <one-content
              :names="'机关建设'"
              :id="7"
              :path="'/construction'"
            ></one-content>
          </div>
          <!-- 委员天地 -->

          <two-content
            :name1="'以史资政'"
            :name2="'他山之石'"
            :id1="12"
            :id2="13"
            :path1="'/history'"
            :path2="'/stones'"
          ></two-content>
          <!-- 添加 -->
        </div>

        <!-- 第七部分 -->
      </div>
    </div>
    <div>
      <router-view></router-view>
    </div>
    <div
      style="
        background: #015293;
        color: #fff;
        padding: 20px 0;
        margin: 20px 0 0;
      "
      class="xglj"
      v-if="linkList.length"
    >
      <div
        style="
          display: flex;
          justify-content: center;
          width: 1200px;
          margin: 0 auto;
        "
      >
        <div
          style="
            margin-right: 20px;
            line-height: 40px;
            font-size: 18px;
            width: 120px;
          "
        >
          相关链接
        </div>
        <div style="margin-right: 10px">
          <el-select
            v-model="link0"
            @change="selectChange"
            placeholder="中国政协传媒网"
          >
            <el-option
              v-for="(item, index) in linkList[0]"
              :key="index"
              :label="item.name"
              :value="item.link"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-right: 10px">
          <el-select
            v-model="link1"
            @change="selectChange"
            placeholder="党政网"
          >
            <el-option
              v-for="(item, index) in linkList[1]"
              :key="index"
              :label="item.name"
              :value="item.link"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-right: 10px">
          <el-select
            v-model="link2"
            @change="selectChange"
            placeholder="党派团体网"
          >
            <el-option
              v-for="(item, index) in linkList[2]"
              :key="index"
              :label="item.name"
              :value="item.link"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-right: 10px">
          <el-select
            v-model="link3"
            @change="selectChange"
            placeholder="省辖市政协网"
          >
            <el-option
              v-for="(item, index) in linkList[3]"
              :key="index"
              :label="item.name"
              :value="item.link"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-right: 10px">
          <el-select
            v-model="link4"
            @change="selectChange"
            placeholder="群团组织网"
          >
            <el-option
              v-for="(item, index) in linkList[4]"
              :key="index"
              :label="item.name"
              :value="item.link"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-right: 10px">
          <el-select
            v-model="link5"
            @change="selectChange"
            placeholder="相关媒体"
          >
            <el-option
              v-for="(item, index) in linkList[5]"
              :key="index"
              :label="item.name"
              :value="item.link"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-right: 10px">
          <el-select
            v-model="link6"
            @change="selectChange"
            placeholder="市县政协网"
          >
            <el-option
              v-for="(item, index) in linkList[6]"
              :key="index"
              :label="item.name"
              :value="item.link"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="footer1">
      <div class="footer-content">
        <div>
          <a href="http://biaozhi.conac.cn/">
            <img src="../../static/image/home/red.png" />
          </a>
        </div>
        <div class="footer-content-right">
          <div class="footer-text" style="display: flex; align-items: center">
            <a href="#/">首页</a>&nbsp; | &nbsp;<a
              :href="'#/pageDetails?id=' + 747 + '&name=' + '联系我们'"
              >联系我们</a
            >
          </div>
          <div class="footer-text" style="display: flex; align-items: center">
            版权所有：{{ dbxx.banquan }} &nbsp;&nbsp;&nbsp;&nbsp; 运行维护：{{
              dbxx.yunwei
            }}
          </div>
          <div class="footer-text" style="display: flex; align-items: center">
            地址：{{ dbxx.dizhi }} | 邮编：{{ dbxx.youbian }} | 网站标识码：{{
              dbxx.biaoshi
            }}
          </div>
          <div class="footer-text" style="display: flex; align-items: center">
            <span> {{ dbxx.yuICP }} </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <img
              src="../../static/img/new/huizhangIcon.png"
              alt=""
              style="width: 18px; height: 20px"
            />&nbsp;
            <span> {{ dbxx.yugongwang }} </span>
          </div>
        </div>
        <div style="padding-left: 50px">
          <a
            href="https://zfwzzc.www.gov.cn/check_web/errorInfo/search"
            target="_blank"
          >
            <img
              src="../../static/img/new/zfzcwz.png"
              alt=""
              style="width: 127px; height: 60px"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lib from '../api/index';
export default {
  data() {
    return {
      link0: '',
      link1: '',
      link2: '',
      link3: '',
      link4: '',
      link5: '',
      link6: '',
      topTab: 0,
      hotRow: {},
      searchTitle: '',
      defaultImg:
        'this.src="' + require('../../static/image/home/img1.jpg') + '"',

      radio: '',
      checkList: [],
      navList: [
        //621修改
        { path: '/', text: '首页' },
        { path: '/general', text: '政协概况' },
        { path: '/imporantnews', text: '政协要闻' },
        { path: '/zxhy', text: '重要会议' }, //不确定 621修改
        { path: '/scdy', text: '视察调研' },
        { path: '/specialCommittee', text: '专委会工作' },
        { path: '/mzdp', text: '民主党派' }, //暂无 621修改
        { path: '/construction', text: '机关建设' },
        { path: '/PartyConstruction', text: '党风廉政' },

        // { path: '/democratic', text: '时政动态' },
        // { path: '/specialCommittee', text: '专委会工作' },
        // { path: '/proposer', text: '提案工作' },
        // { path: '/social', text: '社情民意' },
        // { path: '/construction', text: '机关建设' },
        // { path: '/PartyConstruction', text: '党风廉政' },
      ],
      imporantnewsList: [], //政协要闻
      oneList: [],
      twoList: [],
      threeList: [],
      pathList: [
        '/',
        '/imporantnews',
        '/general',
        '/democratic',
        '/specialCommittee',
        '/proposer',
        '/social',
        '/construction',
        '/PartyConstruction',
      ],
      pathListTwo: [
        'democratic',
        'specialCommittee',
        'video',
        'inform',
        'proposer',
        'social',
        'county',
        'political',
        'history',
        'stones',
        'construction',
        'committeemember',
        'study',
        'xuzhou',
        'imporantnews',
        'themevideo',
        'collectadvice',
        'messageboard',
      ],
      isShow: false,
      swiperList: [],
      imageList: [],
      list1: [
        {
          text: '各省政协',
          isSelect: true,
          img1Src: 'static/image/home/list04.jpg',
        },
        {
          text: '市县政协',
          isSelect: false,
          img1Src: 'static/image/home/list03.jpg',
        },
        {
          text: '本地链接',
          isSelect: false,
          img1Src: 'static/image/home/list03.jpg',
        },
        {
          text: '精选网站',
          isSelect: false,
          img1Src: 'static/image/home/list03.jpg',
        },
      ],
      newList: [],
      tabTaggList: [],
      linkList: [],
      dbxx: {},
      tpList: [],
      appImgs: {},
    };
  },

  created() {
    this.newList = this.rebackList;
    this.getData('imporantnewsList', 1); //政协要闻

    this.getData('tpList', 15); //政协要闻
    lib
      .portalbanner({
        params: {
          type: 0,
        },
      })
      .then((r) => {
        if (r.code == 2000) {
          this.swiperList = r.data;
        }
      });
    lib.getAppImgs().then(({ data }) => {
      this.appImgs = data;
    });
    this.getHotNew();
    this.getinformationList();
    this.getappJournalismlianjie();
    this.getjournalismdibuxinxi();
  },
  methods: {
    getjournalismdibuxinxi() {
      lib.journalismdibuxinxi().then((res) => {
        this.dbxx = JSON.parse(res.data.datum);
      });
    },
    selectChange(a, b) {
      if (a != '001') {
        window.open(a);
      }
    },
    getappJournalismlianjie() {
      lib.appJournalismlianjie().then((res) => {
        if (res.data) {
          this.linkList = JSON.parse(res.data.datum);
        }
      });
    },
    getinformationList() {
      lib
        .informationList({ params: { page: 1, size: 8, classifyId: 17 } })
        .then((res) => {
          this.tabTaggList = res.data.records;
        });
    },
    //热点新闻
    getHotNew() {
      lib.hotNew().then((r) => {
        if (!r.data.length) return;
        this.hotRow = r.data[0];
        this.hotRow.content = this.hotRow.content
          .replace(/<\/?(img)[^>]*>/gi, '')
          .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, '\n')
          .replace(/<br\/?>/gi, '\n')
          .replace(/<[^>/]+>/g, '')
          .replace(/(\n)?<\/([^>]+)>/g, '')
          .replace(/\u00a0/g, ' ')
          .replace(/&nbsp;/g, ' ')
          .replace(/<\/?(img)[^>]*>/gi, '')
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&#39;/g, "'")
          .replace(/&quot;/g, '"')
          .replace(/<\/?.+?>/g, '');
      });
    },
    searchClick() {
      this.$router.push({
        path: '/OnlineSearch',
        query: {
          title: this.searchTitle,
        },
      });
      location.reload();
    },
    checkChange(a) {},
    investigationClick(id, type) {
      let options;
      if (type == 2) {
        options = this.checkList.join(',');
      } else if (type == 1) {
        options = this.radio;
      }
      if (options != '') {
        lib
          .votingSubmit({
            params: {
              id: id,
              type: type,
              options: options,
            },
          })
          .then((r) => {
            if (r.code == 2000) {
              this.$message({
                message: '提交成功',
                type: 'success',
              });
              this.checkList = [];
              this.radio = '';
            }
          });
      } else {
        this.$message({
          message: '请勾选选项之后再提交！',
          type: 'warning',
        });
      }
    },

    //点击进入详情页
    goDetails1(item, names) {
      this.searchTitle = '';
      if (item.link == null || item.link == '') {
        this.$router
          .push({
            path: '/pageDetails',
            query: {
              id: item.id,
              name: names,
            },
          })
          .catch((r) => r);
      } else {
        location.href = item.link;
      }
    },
    xialaClick() {
      this.isShow = !this.isShow;
      this.newList = this.rebackList;
    },
    goClick1(index, item) {
      this.searchTitle = '';
      this.$router
        .push({
          path: item.path,
        })
        .catch((r) => r);
    },
    goClick2(index) {
      this.$router
        .push({
          path: this.pathListTwo[index],
        })
        .catch((r) => r);
    },
    //最下面一部分省市

    getData(arr, id) {
      lib
        .appInformationList({
          params: {
            page: 1,
            size: 10,
            classifyId: id,
          },
        })
        .then((res) => {
          this[arr] = res.data.records;
          // console.log(this.democraticList, 'democraticList', 'oo');
        });
    },
  },
  computed: {
    isOption() {
      if (this.$route.path == '/pageDetails') {
        return this.$route.query.name;
      } else {
        console.log('1111', this.$router.name);
        return this.$route.name;
      }
    },
    xiala() {
      if (this.isShow == false) {
        return (this.newList = this.newList.slice(0, 18));
      } else {
        return (this.newList = this.newList);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mr36{
  margin-right: 36px;
}
.wzabtn {
  border: 1px solid #015293;
  line-height: 34px;
  box-sizing: border-box;
  width: 110px;
  text-align: center;
  border-radius: 5px;
  color: #015293;
  cursor: pointer;
  position: absolute;
  top: -54px;
  right: 0;
  text-decoration: none;
}
.footer-content-right a {
  text-decoration: none;
  color: inherit;
}
.greybox {
  height: 65px;
  width: 100%;
  margin-bottom: 10px;
}
.ellipsis {
  white-space: nowrap; /* 规定文本是否折行 */
  overflow: hidden; /* 规定超出内容宽度的元素隐藏 */
  text-overflow: ellipsis;
  padding: 0 40px;
}
/* .s8-right-line{
  display: flex;
} */
.s8-right-bottom >>> .el-progress-bar {
  width: 95%;
}
.s8-right-bottom >>> .el-progress-bar__outer {
  width: 480px;
}
.el-progress {
  display: inline-block;
  width: 80%;
}
.s8-right-bottom {
  width: 96%;
  /* height: 150px; */
  padding: 10px 2%;
  /* background-color: khaki; */
  line-height: 28px;
}
.s8-right-top {
  width: 96%;
  height: 45px;
  line-height: 45px;
  background-color: gainsboro;
  padding: 0 2%;
  font-size: 20px;
}
.s8-right {
  width: 68%;
  height: 100%;
  /* background-color: indigo; */
  border: 1px solid gainsboro;
}
.video-submit {
  width: 80px;
  height: 30px;
  margin: auto;
  background-color: #eaf5f9;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
}
.s8-img {
  width: 100%;
  /* height: 140px; */
  margin-bottom: 5px;
}
.s8-left {
  width: 28%;
  height: 100%;
  /* background-color: darkcyan; */
}
.section8 {
  width: 1100px;
  height: 250px;
  margin: auto;
  /* background-color: coral; */
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.section2-left >>> .el-carousel__arrow {
  width: 45px;
  height: 45px;
  background-color: rgba(68, 64, 63, 0.7);
  font-size: 20px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
/* 位置 */
.all-content {
  width: 1100px;
  margin: 0 auto;
}
.location {
  background-color: rgb(243, 243, 243);
  background-image: url(../assets/img/bg.jpg);

  padding-top: 10px;
  padding-bottom: 10px;
}
.break {
  display: inline-block;
}
.el-icon-location-outline {
  margin-left: 10px;
}
.now-location {
  display: inline-block;
  font-size: 13px;
  position: relative;
  top: -2px;
}

.text-spe {
  color: gold;
}
.content-spe {
  display: none;
}
.footer-text {
  height: 30px;
}
.footer-content-right {
  margin-left: 20px;
}
.footer-content img {
  width: 102px;
  height: 102px;
}
.footer-content {
  /* width: 70%; */
  width: 1200px;
  height: 80%;
  margin: auto;
  justify-content: center;
  /* background-color: #b2f2fe; */
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  color: #777777;
}
.footer1 {
  width: 100%;
  height: 200px;
  margin: auto;

  background-color: #eeeeee;
  /* margin-top: 50px; */
}

a:hover {
  cursor: pointer;
}
ul {
  margin-left: 10px;
  padding: 0;
}
ul li {
  width: 100%;
  height: 28px;
  line-height: 28px;
  margin-top: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.s7-content-1 a:hover {
  color: #ed0505;
}
.s7-content-2 {
  width: 100%;
  text-align: center;
}
.s7-content-1 {
  width: 11%;
  height: 35px;
  line-height: 30px;
}
.s7-content {
  width: 100%;
  display: flex;
  /* justify-content: space-around; */
  flex-wrap: wrap;
  /* height: 100px; */
  /* background-color: cadetblue; */
  margin-top: 10px;
}
.s7-title-spe {
  color: #015293;
  font-weight: bold;
}
.s7-title-left {
  width: 40%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.s7-title {
  width: 100%;
  height: 45px;
  border-bottom: 1px solid gainsboro;
}
.section7 {
  width: 100%;
  /* height: 200px; */
  /* background-color: brown; */
  margin-top: 20px;
  border-top: 2px solid #015293;
}
.s6-bottom-1 {
  width: 40%;
  border: 1px solid #015293;
  overflow: hidden;
}
.s6-bottom-1 img:hover {
  transform: scale(1.2);
  transition: linear 0.5s;
}
.s6-bottom-1 img {
  width: 100%;
  height: 100%;
}
.s6-bottom {
  width: 96%;
  height: 69%;
  margin-top: 10px;
  /* background-color: indigo; */
  display: flex;
  justify-content: space-between;
  margin-left: 4%;
}
.section6 {
  width: 100%;
  /* height: 520px; */
  /* background-color: indianred; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.s5-right-3 {
  width: 100%;
  height: 130px;
  /* background-color: chocolate; */
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.s5-right li {
  color: #015293;
}
.s5-right a:hover {
  color: #ed0505;
}
.s5-right {
  width: 342px;
  height: 100%;
  /* background-color: aquamarine; */
}
.s5-left-bottom-1-text {
  padding: 6px 10px;
  background-color: #F5F5F5;
  height: 54px;
  box-sizing: border-box;
}
.s5-left-bottom-1-img {
  width: 100%;
  height: 100%;
}
.s5-left-bottom {
    width: calc(100% + 25px);
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  color: #015293;
}
.s5-left-bottom-1 {
  width: 25%;
  height: 47%;
  overflow: hidden;
  background-color: #f5f5f5;
  margin-left: 5px;
}
.s5-left-bottom a:hover {
  color: #ed0505;
}
.s5-left-bottom img:hover {
  transform: scale(1.2);
  transition: linear 0.5s;
}
.div-img {
  width: 100%;
  overflow: hidden;
  height: 164px;
  margin-bottom: 4px;
  background-color: #e7f2f8;
}
.s5-left {
  width: 67%;
  height: 100%;
}
.section5 {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
.appDownload {
    width: 100%;
    padding-bottom: 8px;
    background: #D4E5F5;
    color: #222222;
    margin-bottom: 20px;
    .tit {
      text-align: justify;
      font-size: 18px;
      font-weight: bold;
      padding: 6px 32px 4px;
      height: 1.5em;
      overflow: hidden;
      &::after {
        content: '';
        width: 100%;
        display: inline-block;
        height: 0;
      }
    }
    .imgs {
      padding: 0 20px;
      justify-content: space-around;
      img {
        width: 100px;
        height: 100px;
      }
      span {
        writing-mode: vertical-lr;
        text-align: center;
        margin-left: 5px;
        font-size: 16px;
      }
    }
  }
.section4 {
  width: 100%;
  margin-bottom: 20px;
  /* height: 180px; */
  /* background-color: bisque; */
}
.v-img {
  width: 100%;
}
.v-img:hover {
  transform: scale(1.2);
  transition: linear 0.5s;
}
.video-img {
  width: 96%;
  margin-top: 10px;
  padding: 0 2%;
  /* border: 1px solid gainsboro; */
  overflow: hidden;
}
.list1 {
  margin-right: 3%;
}
.section3-left a:hover {
  color: #ed0505;
}
.s5-left-bottom>.flexbox:nth-last-child(1){}
.s3-left-title {
  height: 45px;
  line-height: 45px;
  padding-left: 1%;
  /* background-color: coral; */
  background: linear-gradient(-90deg, #ffffff 0%, #cee2f3 100%);
  color: #015293;
  font-size: 20px;
  font-weight: bolder;
}
.s6-title-spe {
  border: none;
  text-align: center;
}
.section3-left {
  width: 32%;
  height: 100%;
  /* background-color: cadetblue; */
}
.section3 {
  width: 100%;
  height: 250px;
  /* background-color: aquamarine; */
  display: flex;
  justify-content: space-between;
  /* margin-top: -25px; */
}
.s2-right-1 li {
  color: #015293;
}
.s2-right-1 a:hover {
  color: #ed0505;
}
.s2-right-1-title {
  height: 100%;
  display: flex;
  align-items: center;
  color: white;
  font-weight: bolder;
  font-size: 20px;
}
.s3-left-title-spe {
  margin: 0 15px;
}
.s2-right-1-title a {
  height: 100%;
  display: flex;
  color: #333333;
  justify-content: center;
  align-items: center;
  font-weight: bolder;
  font-size: 20px;
}
a:hover {
  color: inherit;
}
.s2-right-1-title .active {
  color: #015293;
}
.s2-right-1-title a:hover {
  color: #015293;
}
.s2-right-1 {
  width: 100%;
  height: 45px;
  background-color: #f5f5f5;
}
.swiper-text {
  width: 97%;
  height: 45px;
  line-height: 45px;
  background-color: rgba(5, 5, 5, 0.5);
  color: white;
  font-size: 19px;
  position: absolute;
  bottom: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 3%;
}
.swiper-img {
  width: 100%;
  height: 368px;
}
.section2-left {
  width: 48.5%;
  height: 100%;
  /* background-color: aquamarine; */
  position: relative;
}
.section2 {
  width: 100%;
  height: 368px;
  /* background-color: antiquewhite; */
  margin-top: 20px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
}
.top a:hover {
  color: #015293;
}
.bottom {
  width: 90%;
  margin: auto;
  font-size: 18px;
  margin-top: 5px;
  color: #015293;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.bottom:hover {
  color: #ed0505;
}
.bottom-1 {
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.top {
  font-size: 32px;
  font-weight: bolder;
  color: #ed0505;
  cursor: pointer;
}
.section1 {
  width: 100%;
  height: 75px;
  background-color: #f5f5f5;
  text-align: center;
  padding: 10px 0;
}
.index {
  width: 100%;
  /* height: 800px; */
  /* background-color: lightsalmon; */
}
.total {
  width: 1100px;
  /* height: 2100px; */
  /* background-color: lightblue; */
  margin: auto;
  margin-top: 20px;
}
.header-nav {
  width: 100%;
  height: 50px;
  background-color: #015293;
  position: absolute;
  bottom: -50px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  font-size: 25px;
  color: white;
  font-weight: bolder;
}
.header-nav a:hover {
  color: gold;
}
.search-icon {
  font-size: 22px;
  color: #0070c9;
  position: absolute;
  right: 10px;
  top: 7px;
}
.input1 {
  width: 80%;
  height: 30px;
  outline: none;
  border: none;
  border-radius: 5px;
  color: black;
  padding-left: 10px;
  background-color: rgba(250, 250, 250, 0);
  overflow: hidden;
}
.header-search {
  width: 23%;
  height: 32px;
  position: absolute;
  /* background-color: cadetblue; */
  background-color: rgba(250, 250, 250, 0.5);
  border: 1px solid #0070c9;
  border-radius: 5px;
  right: 0;
  top: 93px;
}
.logo {
  margin-top: 60px;
}
.header-content {
  width: 1100px;
  height: 180px;
  background-size: 100% 100%;
  // background-image: url('../assets/v2img/1.png');
  margin: auto;
  position: relative;
}
.header {
  width: 100%;
  height: 230px;
  margin: auto;
  background-size: cover;
  margin-bottom: 20px;
  /* background-repeat: no-repeat; */
}
.box {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  position: relative;
}
.s3-left-title a:hover {
  // color: rgb(236, 75, 26);
}
.section3-left-spe {
  /* background-color: darkgrey; */
  border: 1px solid gainsboro;
  height: 230px;
}
.video-img >>> .el-checkbox {
  width: 80px;
  /* height: 30px; */
  margin-top: 15px;
}
.s8-right-bottom >>> .el-radio {
  display: inline-block;
}
/* .s8-right-bottom >>> .el-progress-bar {
  width: 300px;
  display: inline-block;
} */
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue